import { useState } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@bizop/ui-kit";

import { router } from "./router";
import { useTheme, useDensity } from "@bizop/ui-kit";

/**
 * App root.
 *
 * Wires the global providers in the right order:
 *   1. QueryClientProvider — TanStack Query cache.
 *   2. Theme + density hooks (touch the DOM dataset; no provider needed).
 *   3. RouterProvider + Toaster.
 *
 * Tooltip provider is expected to be supplied by `@bizop/ui-kit/Tooltip` at
 * the call site; we don't wrap the whole tree in one to keep nesting flat.
 */
export function App() {
  // Activate theme/density hooks at app root so localStorage stays in sync
  // and the dataset attributes get re-applied on system theme changes.
  useTheme();
  useDensity();

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  );
}
